import ApiService from '../api.service'

const TazApiService = {
    // ------------------- TAZ Rep data search
    async searchRepsForWebQuote (payload) {
        const url = `/api/TazApi/searchRepsForWebQuote`
        const requestData = {
            method: 'post',
            url: url,
            data: payload,
        }

        try {
            const response = await ApiService.customRequest(requestData)
            return response.data
        } catch (ex) {
            throw ex
        }
    },

    // -------------------end  TAZ Rep data search

    // ------------------- TAZ Territory data search
    async getAllTerritories (payload) {
        const url = `/api/TazApi/getAllTerritories`
        const requestData = {
            method: 'post',
            url: url,
            data: payload,
        }

        try {
            const response = await ApiService.customRequest(requestData)
            return response.data
        } catch (ex) {
            throw ex
        }
    },

    // -------------------end  TAZ Territory data search

    // ------------------- TAZ Marker data search
    async getFacilitiesForMap (payload) {
        const url = `/api/TazApi/getFacilitiesForMap`
        const requestData = {
            method: 'post',
            url: url,
            data: payload,
        }

        try {
            const response = await ApiService.customRequest(requestData)
            return response.data
        } catch (ex) {
            throw ex
        }
    },

    // -------------------end  TAZ Marker data search

    // ------------------- TAZ Customer/Facility data search
    async getRepListByZipCodeReport (payload) {
        const url = `/api/TazApi/getRepListByZipCodeReport`
        const requestData = {
            method: 'post',
            url: url,
            data: payload,
        }

        try {
            const response = await ApiService.customRequest(requestData)
            return response.data
        } catch (ex) {
            throw ex
        }
    },
    // -------------------end  TAZ Customer/Facility data search

    // ----------------- Table MapSavedMap
    loadSavedMap: async (id) => {
        const url = `/api/TazApi/loadSavedMap?id=${id}`

        const requestData = {
            method: 'post',
            url: url,
            data: {},
        }

        try {
            const response = await ApiService.customRequest(requestData)
            return response.data
        } catch (ex) {
            throw ex
        }

    },
    getSavedMaps: async () => {
        const url = `/api/TazApi/getSavedMaps`

        const requestData = {
            method: 'post',
            url: url,
            data: {},
        }

        try {
            const response = await ApiService.customRequest(requestData)
            return response.data
        } catch (ex) {
            throw ex
        }

    },
    async saveSavedMap (payload) {
        const url = `/api/TazApi/saveSavedMap`
        const requestData = {
            method: 'post',
            url: url,
            data: payload,
        }

        try {
            const response = await ApiService.customRequest(requestData)
            return response.data
        } catch (ex) {
            throw ex
        }
    },
    // ----------------- End Table MapSavedMap

    // ------------------- GeoJson data retrieve
    async getTerrZipGeoJson (payload) {
        const url = `/api/TazApi/getTerrZipGeoJson`
        const requestData = {
            method: 'post',
            url: url,
            data: payload,
        }

        try {
            const response = await ApiService.customRequest(requestData)
            return response.data
        } catch (ex) {
            throw ex
        }
    },

    // -------------------end  GeoJson data retrieve


}

export default TazApiService